import styled from 'styled-components'

export const StyledRolesPermissions = styled.div`
width:100%;
background-color:white;
padding:1rem;
`



export const StyledLeaveCard = styled.div`
  width: 100%;
  background-color: #faf9f6;
  margin-top: 1rem;
  padding: 1rem;
`;

export const StyledInnerLeaveCard = styled.div`
  width: 100%;
  background-color: white;

  h1 {
    padding: 1rem;
    font-size: 1.7rem;
    font-weight: lighter;
  }
`;

export const StyledGrayLine = styled.div`
  border: 0.009rem solid lightgray;
`;

export const StyledShowandSearchContainer = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: space-between;
`;

export const StyledShow = styled.div`
  display: flex;
  width: 15%;

  gap: 0.5rem;
  align-items: center;

  h1 {
    font-size: 1rem;
    font-weight:lighter;
  }
`;

export const StyledSearch = styled.div`
  display: flex;
  margin-right: 2rem;
  align-items: center;

  input {
    width: 100%;
    height: 1.7rem;
  }

  h1 {
    font-size: 1.1rem;
    font-weight:lighter;
  }
`;

export const StyledTableCard = styled.div`
  margin-left: 1rem;
  margin-right: 1rem;
`;


export const StyledFlexForm = styled.div`
  line-height:0.5rem;
`
